<template>
  <div class="share-whatsapp-wrapper">
    <p class="title">WhatsApp</p>
    <div>
      <p v-if="file.size < 5 * 1024 * 1024">{{$tf('WhatsAppExplanation')}}</p>
      <p v-else>{{$tf('WhatsAppBigExplanation')}}</p>
      <div class="button-wrapper">
        <v-btn v-if="!loading" @click="submitHandler" class="whatsapp-button" depressed>
          <img class="whatsapp-logo" src="../../../assets/WhatsApp_Logo_2.png" alt="Whatsapp Icon" />
          {{$tf('Send to my WhatsApp')}}
        </v-btn>
        <v-progress-circular indeterminate v-if="loading" style="visibility: visible"></v-progress-circular>
      </div>
      <div v-if="whatsAppResponse" class="info-wrapper">
        <p v-if="whatsAppResponse === 'ok'" class="success-pill"><v-icon>check</v-icon>{{$tf('Please check your phone')}}</p>
        <p v-if="whatsAppResponse === 'error'" class="error-pill">{{$tf('Error sending SMS') + '. ' + $tf('Please try again later') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { useWhatsApp } from '~/commons/whatsapp'
export default {
  name: 'ShareWhatsAppCard',
  data () {
    return {
      loading: false,
      whatsAppResponse: false
    }
  },
  props: {
    flat: {
      type: Boolean,
      default: false
    },
    file: {
      type: Object,
      default: null
    }
  },
  setup (props, { root: { $store, $tf } }) {
    const { sendWhatsappNotification } = useWhatsApp($store, $tf)
    return {
      sendWhatsappNotification
    }
  },
  computed: {
    whatsappMethods () {
      return useWhatsApp(this.$store, this.$tf)
    }
  },
  methods: {
    submitHandler () {
      this.loading = true
      this.sendWhatsappNotification(this.file.id_file).then(
        r => {
          this.whatsAppResponse = 'ok'
        }
      ).catch(e => {
        this.whatsAppResponse = 'error'
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
.share-whatsapp-wrapper {
  margin-bottom: 2rem;
  .title {
    font-size: 20px;
    font-weight: bold;
    margin: 1rem 0;
  }
  .button-wrapper {
    display: flex;
    justify-content: center;
  }
  .info-wrapper {
    display: flex;
    flex-direction: column;
    padding: 1rem;
    justify-content: center;
    align-items: center;
  }
  button.btn.whatsapp-button {
    background-color: #25d366;
    color: #fff;
    display: inline-block;
    margin: auto;
  }
  .whatsapp-logo {
    path {
      fill: white;
    }
    height: 28px;
    width: 28px;
    margin-right: 0.5rem;
  }

}

</style>



// WEBPACK FOOTER //
// src/components/common/share/ShareWhatsAppCard.vue